export default __webpack_public_path__ + "static/store-one.zh-hant-0833bd6514968b3b1b62af270fb5a8ea.png";